import { createStore, combineReducers, compose } from 'redux';

const initialSidebarState = {
  departments: [],
  selectedDept: null,
  subdepartments: [],
  selectedSubdept: null,
  loadingDepts: true,
  deptsError: null,
  loadingSubdepts: false,
  subdeptsError: null,
  deptSearch: '',
  sidebarCollapsed: false,
};

function sidebarReducer(state = initialSidebarState, action) {
  switch (action.type) {
    case 'sidebar/setDepartments':
      return { ...state, departments: action.payload };
    case 'sidebar/selectDept':
      return { ...state, selectedDept: action.payload, selectedSubdept: null };
    case 'sidebar/setSubdepartments':
      return { ...state, subdepartments: action.payload };
    case 'sidebar/selectSubdept':
      return { ...state, selectedSubdept: action.payload };
    case 'sidebar/setLoadingDepts':
      return { ...state, loadingDepts: action.payload };
    case 'sidebar/setDeptsError':
      return { ...state, deptsError: action.payload };
    case 'sidebar/setLoadingSubdepts':
      return { ...state, loadingSubdepts: action.payload };
    case 'sidebar/setSubdeptsError':
      return { ...state, subdeptsError: action.payload };
    case 'sidebar/setDeptSearch':
      return { ...state, deptSearch: action.payload };
    case 'sidebar/toggleCollapsed':
      return { ...state, sidebarCollapsed: !state.sidebarCollapsed };
    default:
      return state;
  }
}

const initialReportsState = {
  reports: [],
  loadingReports: false,
  reportsError: null,
  reportSearch: '',
  reportsCollapsed: false,
};

function reportsReducer(state = initialReportsState, action) {
  switch (action.type) {
    case 'reports/setReports':
      return { ...state, reports: action.payload };
    case 'reports/setLoading':
      return { ...state, loadingReports: action.payload };
    case 'reports/setError':
      return { ...state, reportsError: action.payload };
    case 'reports/setSearch':
      return { ...state, reportSearch: action.payload };
    case 'reports/toggleCollapsed':
      return { ...state, reportsCollapsed: !state.reportsCollapsed };
    default:
      return state;
  }
}

const initialTabsState = {
  openTabs: [],
  activeTab: null,
  tabReportInfo: {},
  embedInfo: {},
  loadingEmbed: {},
  embedError: {},
  isClosingTab: false,
};

function tabsReducer(state = initialTabsState, action) {
  switch (action.type) {
    case 'tabs/setOpenTabs':
      return { ...state, openTabs: action.payload };
    case 'tabs/setActiveTab':
      return { ...state, activeTab: action.payload };
    case 'tabs/setTabReportInfo':
      return { ...state, tabReportInfo: action.payload };
    case 'tabs/setEmbedInfo':
      return { ...state, embedInfo: action.payload };
    case 'tabs/setLoadingEmbed':
      return { ...state, loadingEmbed: action.payload };
    case 'tabs/setEmbedError':
      return { ...state, embedError: action.payload };
    case 'tabs/setIsClosingTab':
      return { ...state, isClosingTab: action.payload };
    case 'tabs/addTab':
      return { 
        ...state, 
        openTabs: state.openTabs.includes(action.payload) ? state.openTabs : [...state.openTabs, action.payload] 
      };
    case 'tabs/removeTab':
      return { 
        ...state, 
        openTabs: state.openTabs.filter(tab => tab !== action.payload),
        tabReportInfo: Object.fromEntries(
          Object.entries(state.tabReportInfo).filter(([key]) => key !== action.payload)
        ),
        embedInfo: Object.fromEntries(
          Object.entries(state.embedInfo).filter(([key]) => key !== action.payload)
        ),
        loadingEmbed: Object.fromEntries(
          Object.entries(state.loadingEmbed).filter(([key]) => key !== action.payload)
        ),
        embedError: Object.fromEntries(
          Object.entries(state.embedError).filter(([key]) => key !== action.payload)
        ),
      };
    case 'tabs/removeAllTabs':
      return { ...initialTabsState };
    default:
      return state;
  }
}

const rootReducer = combineReducers({
  sidebar: sidebarReducer,
  reports: reportsReducer,
  tabs: tabsReducer,
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(rootReducer, composeEnhancers());

export default store; 